namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{
			export class CompanyEntry extends AbstractEntry
			{

				private m_Company: Wollmilch.CompanyObject;

				public constructor( obj: Wollmilch.CompanyObject, orga: OrgaTree )
				{
					super( orga );

					this.m_Company = obj;

					this.clearTitle();
				}

				public rebuild( root?: ui.base.BaseHTMLElement<HTMLElement> | JQuery<HTMLElement> ): CompanyEntry
				{
					super.rebuild( root );

					this.buildBasicInfo();
					new SPA.gui.view.AccountView( this.m_Company ).rebuild( this );

					return this;
				}

				private buildBasicInfo()
				{
					ui.$$.div()
						.appendTo( this.Root() )
						.append('<h2>Organisation - Firma</h2>')
						.append(
							new SPA.gui.address.AddressSection( this.m_Company, this.m_Orga ).rebuild().Root()
						);
				}

			}
		}
	}
}
